import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
    color: "#222A38",
    fontSize: "18px",
  },
  accordionSummary: {
    backgroundColor: "#f9f9f9",
    borderBottom: "1px solid #d0d0d0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 16px",
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  dateText: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#222A38",
  },
  selectAllContainer: {
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    backgroundColor: "#f1f1f1",
    borderBottom: "1px solid #d0d0d0",
  },
  checkbox: {
    marginRight: "8px",
  },
  selectAllText: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  lineItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    borderBottom: "1px solid #d0d0d0",
    width: "100%",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  tranchesSection: {
    backgroundColor: "#fff",
    borderTop: "1px solid #d0d0d0",
    borderBottom: "1px solid #d0d0d0",
    maxHeight: "300px",
    overflowY: "auto",
  },
  accordionDetails: {
    flexDirection: "column",
    padding: 0,
    width: "100%",
  },
  accordion: {
    marginBottom: "12px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    overflow: "hidden",
  },
  checkboxSummary: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
  },
}));

export default useStyles;
